import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: IAuthState = {
  isAuth: false,
  user: null,
  isMFAVerified: false,
  isLoggingIn: false,
  permissionsRefetched: false
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<boolean>) => {
      state.isAuth = action.payload
      if (!action.payload) {
        state.user = null
        state.isMFAVerified = false
      }
    },
    setUser: (state, action: PayloadAction<AdminUser>) => {
      state.user = action.payload
      state.permissionsRefetched = false
    },
    setMFAVerified: (state, action: PayloadAction<boolean>) => {
      state.isMFAVerified = action.payload
    },
    setIsLoggingIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggingIn = action.payload
      if (!action.payload) {
        state.permissionsRefetched = false
      }
    },
    setUserPermission: (state, action: PayloadAction<AdminUserPermissions>) => {
      if (state.user) {
        state.user.Permissions = action.payload
      }
    },
    setPermissionsRefetched: (state, action: PayloadAction<boolean>) => {
      state.permissionsRefetched = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {
  setAuth,
  setUser,
  setMFAVerified,
  setIsLoggingIn,
  setUserPermission,
  setPermissionsRefetched
} = authSlice.actions

export const authReducer = authSlice.reducer
